/* ==========================================================================
   SICCUS — behaviour layer
   No dependencies. Deferred. Every module is opt-in via a data attribute,
   so an unused section costs nothing at runtime.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.SiccusStrings || {};
  var ROUTES = window.SiccusRoutes || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function money(cents) {
    var fmt = (window.SiccusMoneyFormat || '{{amount}}');
    var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  /* ---------------------------------------------------------------- toast */
  var toastStack;
  function toast(message, linkHref, linkLabel) {
    if (!toastStack) {
      toastStack = document.createElement('div');
      toastStack.className = 'toast-stack';
      toastStack.setAttribute('role', 'status');
      toastStack.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastStack);
    }
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' +
      '<span></span>' + (linkHref ? '<a href="' + linkHref + '"></a>' : '');
    el.querySelector('span').textContent = message;
    if (linkHref) el.querySelector('a').textContent = linkLabel || T.view_cart || 'View cart';
    toastStack.appendChild(el);
    setTimeout(function () {
      el.dataset.leaving = 'true';
      setTimeout(function () { el.remove(); }, 260);
    }, 3600);
  }
  window.siccusToast = toast;

  /* --------------------------------------------------------------- drawer */
  var openLayer = null;
  var lastFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function layerOpen(el) {
    if (!el) return;
    if (openLayer && openLayer !== el) layerClose(openLayer, true);
    lastFocus = document.activeElement;
    el.dataset.open = 'true';
    el.removeAttribute('aria-hidden');
    document.body.classList.add('is-locked');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.dataset.open = 'true';
    openLayer = el;
    var first = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
    if (first) setTimeout(function () { first.focus(); }, 60);
    document.dispatchEvent(new CustomEvent('siccus:layer:open', { detail: { el: el } }));
  }

  function layerClose(el, silent) {
    el = el || openLayer;
    if (!el) return;
    el.dataset.open = 'false';
    el.setAttribute('aria-hidden', 'true');
    if (!silent) {
      document.body.classList.remove('is-locked');
      var overlay = $('[data-overlay]');
      if (overlay) overlay.dataset.open = 'false';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (openLayer === el) openLayer = null;
  }
  window.siccusOpen = function (id) { layerOpen(document.getElementById(id)); };
  window.siccusClose = function () { layerClose(); };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-layer-open]');
    if (opener) { e.preventDefault(); layerOpen(document.getElementById(opener.dataset.layerOpen)); return; }
    var closer = e.target.closest('[data-layer-close]');
    if (closer) { e.preventDefault(); layerClose(); return; }
    if (e.target.matches('[data-overlay]')) layerClose();
  });

  document.addEventListener('keydown', function (e) {
    if (!openLayer) return;
    if (e.key === 'Escape') { layerClose(); return; }
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, openLayer).filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ----------------------------------------------------------------- cart */
  function cartSectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble'].join(',');
  }

  function refreshCart(sections) {
    if (sections) {
      Object.keys(sections).forEach(function (id) {
        var html = new DOMParser().parseFromString(sections[id], 'text/html');
        var incoming = html.querySelector('[data-cart-region="' + id + '"]');
        var current = $('[data-cart-region="' + id + '"]');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      });
      return Promise.resolve();
    }
    return fetch((ROUTES.cart_url || '/cart') + '?sections=' + cartSectionsToRender(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return refreshCart(data); });
  }
  window.siccusRefreshCart = refreshCart;

  function addToCart(payload, opts) {
    opts = opts || {};
    var body = Object.assign({}, payload, { sections: cartSectionsToRender(), sections_url: window.location.pathname });
    return fetch((ROUTES.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || T.cart_error || 'Something went wrong.'); throw res.data; }
        return refreshCart(res.data.sections).then(function () {
          if (opts.silent) return res.data;
          var drawer = document.getElementById('cart-drawer');
          if (drawer && window.SiccusSettings && window.SiccusSettings.cart_drawer) layerOpen(drawer);
          else toast(T.added_to_cart || 'Added to your bag.', ROUTES.cart_url || '/cart');
          return res.data;
        });
      });
  }
  window.siccusAddToCart = addToCart;

  function changeLine(key, quantity) {
    return fetch((ROUTES.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: cartSectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return refreshCart(data.sections).then(function () {
          document.dispatchEvent(new CustomEvent('siccus:cart:updated', { detail: data }));
          return data;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.cartRemove, 0); return; }
    var step = e.target.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      var next = Math.max(0, parseInt(step.dataset.qty, 10) + parseInt(step.dataset.cartStep, 10));
      changeLine(step.dataset.key, next);
    }
  });

  /* ------------------------------------------------------ add-to-cart form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    if (btn) btn.dataset.loading = 'true';
    addToCart({
      items: [{ id: form.querySelector('[name="id"]').value, quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10) }]
    })
      .catch(function () {})
      .then(function () { if (btn) btn.dataset.loading = 'false'; });
  });

  /* ---------------------------------------------------------- quick add */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    if (qa.dataset.quickAdd) {
      qa.dataset.loading = 'true';
      addToCart({ items: [{ id: qa.dataset.quickAdd, quantity: 1 }] })
        .catch(function () {})
        .then(function () { qa.dataset.loading = 'false'; });
    } else if (qa.dataset.quickViewUrl) {
      openQuickView(qa.dataset.quickViewUrl);
    }
  });

  /* --------------------------------------------------------- quick view */
  function openQuickView(url) {
    var modal = document.getElementById('quick-view');
    if (!modal) { window.location.href = url; return; }
    var body = modal.querySelector('[data-quick-view-body]');
    body.innerHTML = '<div class="skeleton skeleton--card"></div><div class="skeleton skeleton--line"></div><div class="skeleton skeleton--line short"></div>';
    layerOpen(modal);
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-quick-view-content]');
        body.innerHTML = content ? content.innerHTML : '';
        initVariantPickers(body);
      })
      .catch(function () { body.innerHTML = '<p class="text-muted">' + (T.quick_view_error || 'Could not load this item.') + '</p>'; });
  }

  /* ------------------------------------------------------ variant picker */
  function initVariantPickers(root) {
    $$('[data-variant-picker]', root || document).forEach(function (picker) {
      if (picker.dataset.bound === 'true') return;
      picker.dataset.bound = 'true';
      var variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
      var form = picker.closest('[data-product-form]') || document.querySelector('[data-product-form]');

      function update() {
        var chosen = $$('input:checked', picker).map(function (i) { return i.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });

        $$('[data-option-value]', picker).forEach(function (label) {
          var name = label.previousElementSibling;
          if (!name) return;
          var idx = parseInt(label.dataset.optionIndex, 10);
          var probe = chosen.slice();
          probe[idx] = label.dataset.optionValue;
          var exists = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === probe[i] : (chosen[i] ? o === chosen[i] : true); });
          });
          name.disabled = !exists;
        });

        $$('[data-selected-value]', picker).forEach(function (out, i) {
          out.textContent = chosen[i] || '';
        });

        var idInput = form && form.querySelector('[name="id"]');
        var btn = form && form.querySelector('[data-add-button]');
        if (match) {
          if (idInput) idInput.value = match.id;
          if (btn) {
            btn.disabled = !match.available;
            btn.textContent = match.available ? (T.add_to_cart || 'Add to bag') : (T.sold_out || 'Sold out');
          }
          document.dispatchEvent(new CustomEvent('siccus:variant:change', { detail: { variant: match } }));
          if (history.replaceState && picker.dataset.updateUrl !== 'false') {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', match.id);
            history.replaceState({}, '', u);
          }
          $$('[data-variant-price]').forEach(function (n) { n.innerHTML = money(match.price); });
          $$('[data-variant-compare]').forEach(function (n) {
            if (match.compare_at_price > match.price) { n.innerHTML = money(match.compare_at_price); n.hidden = false; }
            else n.hidden = true;
          });
        } else if (btn) {
          btn.disabled = true;
          btn.textContent = T.unavailable || 'Unavailable';
        }
      }

      on(picker, 'change', update);
      update();
    });
  }

  /* ------------------------------------------------------------ wishlist */
  var WKEY = 'siccus:wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function saveWishlist(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} }
  function syncWishlist() {
    var list = wishlist();
    $$('[data-wishlist]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.dataset.wishlist) > -1 ? 'true' : 'false'); });
    $$('[data-wishlist-count]').forEach(function (n) { n.textContent = list.length; n.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var list = wishlist(), id = b.dataset.wishlist, i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); toast(T.wishlist_removed || 'Removed from your list.'); }
    else { list.push(id); toast(T.wishlist_added || 'Saved to your list.'); }
    saveWishlist(list);
    syncWishlist();
  });

  /* ------------------------------------------------------ recently viewed */
  function trackRecent() {
    var meta = $('[data-recent-track]');
    if (!meta) return;
    var KEY = 'siccus:recent';
    var list;
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }
    var handle = meta.dataset.recentTrack;
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20))); } catch (e) {}
  }
  function renderRecent() {
    var host = $('[data-recent-render]');
    if (!host) return;
    var list;
    try { list = JSON.parse(localStorage.getItem('siccus:recent')) || []; } catch (e) { list = []; }
    var exclude = host.dataset.exclude;
    list = list.filter(function (h) { return h !== exclude; }).slice(0, parseInt(host.dataset.limit || 8, 10));
    if (!list.length) { host.closest('[data-recent-section]').hidden = true; return; }
    var q = list.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch((ROUTES.search_url || '/search') + '?type=product&q=' + encodeURIComponent(q) + '&view=cards')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelector('[data-card-list]');
        if (cards && cards.children.length) {
          host.innerHTML = cards.innerHTML;
          syncWishlist();
        } else {
          host.closest('[data-recent-section]').hidden = true;
        }
      })
      .catch(function () { host.closest('[data-recent-section]').hidden = true; });
  }

  /* ------------------------------------------------------------- reveals */
  function initReveal() {
    var targets = $$('[data-reveal]');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.dataset.revealed = 'true'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.revealDelay || 0, 10);
        setTimeout(function () { entry.target.dataset.revealed = 'true'; }, delay);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ parallax */
  function initParallax() {
    var nodes = $$('[data-parallax]');
    if (!nodes.length || reduced) return;
    var ticking = false;
    function frame() {
      nodes.forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var progress = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        n.style.transform = 'translate3d(0,' + (progress * (parseFloat(n.dataset.parallax) || 14) * -1).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }

  /* --------------------------------------------------------- sticky bars */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.dataset.visible = entries[0].isIntersecting ? 'false' : 'true';
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(anchor);
  }

  function initHeaderHide() {
    var header = $('[data-header]');
    if (!header) return;
    var last = 0;
    function measure() { document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px'); }
    measure();
    on(window, 'resize', debounce(measure, 150));
    if (header.dataset.hideOnScroll !== 'true') return;
    on(window, 'scroll', function () {
      var y = window.pageYOffset;
      if (y > last && y > 240 && !openLayer) header.dataset.hidden = 'true';
      else header.dataset.hidden = 'false';
      last = y;
    }, { passive: true });
  }

  /* --------------------------------------------------------------- tabs */
  function initTabs() {
    $$('[data-tabs]').forEach(function (group) {
      var triggers = $$('[role="tab"]', group);
      function select(idx) {
        triggers.forEach(function (t, i) {
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          t.tabIndex = i === idx ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = i !== idx;
        });
      }
      triggers.forEach(function (t, i) {
        on(t, 'click', function () { select(i); });
        on(t, 'keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var next = (i + d + triggers.length) % triggers.length;
          triggers[next].focus(); select(next);
        });
      });
      select(0);
    });
  }

  /* ------------------------------------------------------------ gallery */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gal) {
      var dots = gal.parentElement.querySelector('[data-gallery-dots]');
      var items = $$('.gallery-item', gal);
      if (dots && items.length > 1) {
        items.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (T.image || 'Image') + ' ' + (i + 1));
          if (i === 0) b.setAttribute('aria-current', 'true');
          on(b, 'click', function () { items[i].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', inline: 'center', block: 'nearest' }); });
          dots.appendChild(b);
        });
        on(gal, 'scroll', debounce(function () {
          var idx = Math.round(gal.scrollLeft / gal.clientWidth);
          $$('button', dots).forEach(function (b, i) {
            if (i === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          });
        }, 80), { passive: true });
      }
    });

    $$('[data-zoom]').forEach(function (z) {
      on(z, 'click', function (e) {
        var zoomed = z.dataset.zoomed === 'true';
        if (zoomed) { z.dataset.zoomed = 'false'; return; }
        var r = z.getBoundingClientRect();
        z.style.setProperty('--zoom-x', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        z.style.setProperty('--zoom-y', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
        z.dataset.zoomed = 'true';
      });
      on(z, 'mousemove', function (e) {
        if (z.dataset.zoomed !== 'true') return;
        var r = z.getBoundingClientRect();
        z.style.setProperty('--zoom-x', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        z.style.setProperty('--zoom-y', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    });
  }

  /* --------------------------------------------------------- qty stepper */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    e.preventDefault();
    var input = s.parentElement.querySelector('input');
    var next = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------- facets & sorting */
  function initFacets() {
    var form = $('[data-facet-form]');
    if (!form) return;
    var submit = debounce(function () {
      var params = new URLSearchParams(new FormData(form)).toString();
      var url = form.dataset.facetForm + (params ? '?' + params : '');
      renderCollection(url, true);
    }, 260);
    on(form, 'change', submit);
    on(form, 'submit', function (e) { e.preventDefault(); submit(); });
  }

  function renderCollection(url, push) {
    var grid = $('[data-collection-region]');
    if (!grid) return;
    grid.setAttribute('aria-busy', 'true');
    grid.style.opacity = '0.45';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-collection-region]', '[data-facet-region]', '[data-toolbar-region]'].forEach(function (sel) {
          var next = doc.querySelector(sel), cur = $(sel);
          if (next && cur) cur.innerHTML = next.innerHTML;
        });
        if (push) history.pushState({}, '', url);
        grid.removeAttribute('aria-busy');
        grid.style.opacity = '';
        initFacets(); syncWishlist(); initReveal();
        window.scrollTo({ top: (grid.getBoundingClientRect().top + window.pageYOffset - 140), behavior: reduced ? 'auto' : 'smooth' });
      });
  }
  on(window, 'popstate', function () { renderCollection(window.location.href, false); });

  function initInfinite() {
    var sentinel = $('[data-infinite]');
    if (!sentinel || !('IntersectionObserver' in window)) return;
    var loading = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading) return;
      var next = sentinel.dataset.nextUrl;
      if (!next) { io.disconnect(); return; }
      loading = true;
      sentinel.querySelector('[data-infinite-spinner]').hidden = false;
      fetch(next)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-card-list]');
          var list = $('[data-card-list]');
          if (incoming && list) {
            Array.prototype.slice.call(incoming.children).forEach(function (c) { list.appendChild(c); });
          }
          var nextSentinel = doc.querySelector('[data-infinite]');
          sentinel.dataset.nextUrl = nextSentinel ? (nextSentinel.dataset.nextUrl || '') : '';
          if (!sentinel.dataset.nextUrl) io.disconnect();
          sentinel.querySelector('[data-infinite-spinner]').hidden = true;
          loading = false;
          syncWishlist(); initReveal();
        });
    }, { rootMargin: '400px' });
    io.observe(sentinel);
  }

  /* -------------------------------------------------- predictive search */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      results.innerHTML = '<div class="skeleton skeleton--line"></div><div class="skeleton skeleton--line short"></div>';
      fetch((ROUTES.predictive_search_url || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var region = doc.querySelector('[data-predictive-region]');
          results.innerHTML = region ? region.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 220);
    on(input, 'input', run);
  }

  /* --------------------------------------------------------- shipping est */
  function initShipping() {
    $$('[data-ship-form]').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var out = form.parentElement.querySelector('[data-ship-result]');
        var zip = form.querySelector('input').value.replace(/\D/g, '');
        if (zip.length < 8) { out.textContent = T.zip_invalid || 'Enter a valid postcode.'; return; }
        out.textContent = T.zip_checking || 'Checking…';
        // Rates come from checkout; this surfaces the merchant's own promise copy.
        setTimeout(function () { out.textContent = form.dataset.shipForm || ''; }, 420);
      });
    });
  }

  /* ------------------------------------------------------------- marquee */
  function initMarquee() {
    $$('.promo-bar--marquee').forEach(function (bar) {
      var track = bar.querySelector('.promo-track');
      if (!track) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      bar.appendChild(clone);
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    initVariantPickers();
    initReveal();
    initParallax();
    initStickyAtc();
    initHeaderHide();
    initTabs();
    initGallery();
    initFacets();
    initInfinite();
    initSearch();
    initShipping();
    initMarquee();
    syncWishlist();
    trackRecent();
    renderRecent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', function (e) {
    var drawerish = e.target.querySelector('[data-layer-editor-open]');
    if (drawerish) layerOpen(drawerish);
  });
})();
